
        var result = require("!!../../../../../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../../../../../node_modules/css-loader/index.js??ref--8-2!../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--8-3!./student-credit-gaps-panel-current-program.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    